import React from 'react'
import { AuthStepsHeading, AuthStepsParagraph } from '../../constents/components';
import { HR_PORTAL_DOMAIN } from '../../constents/domains';
import { useNavigate } from 'react-router-dom';
import Illustrations from './Illustrations';
import logo from '../../Assets/logo.png';
import loginImage from '../../Assets/loginImage.svg'

const AuthChild = () => {

    const heading = 'Let\'s get you started';
    const paragraph = "Begin your journey toward landing your dream job!";

    const ForHR = {
        heading: 'I\'m hiring candidates',
        detail: 'Post & Manage jobs',
        redirect: HR_PORTAL_DOMAIN,
    };

    const ForCandidates = {
        heading: 'I\'m looking for job',
        detail: 'Apply & Manage jobs applications',
        navigation: '/auth/register',
    };

    const Navigate = useNavigate();
    return (
        <div className='flex flex-col lg:flex-row min-h-screen'>
            <Illustrations
                imgIcon={loginImage}
                mainHeading={"Jobs That Get You"}
                subHeading={"(Because Algorithms Are Smarter Than Your Ex)"}
                bottomText={""}
            >
            </Illustrations >
            <div className='flex flex-col p-4 items-center flex-1 bg-white lg:py-20'>
                <img
                    className=' w-44 hidden md:block'
                    src={logo}
                    alt={"logo-Icon"}
                />
                <AuthStepsHeading text={heading} />
                <AuthStepsParagraph text={paragraph} />
                <div className='flex flex-col gap-3  my-8 md:my-10 lg:my-12 xl:my-16 2xl:my-20'>
                    <div
                        className=' w-full px-4 py-4 rounded-xl border-[0.12rem] border-[#f0f0f0] cursor-pointer md:py-6 lg:rounded-2xl'
                        onClick={(e) => ForHR?.redirect ? window.open(ForHR?.redirect) : Navigate(ForHR?.navigation)}
                    >
                        <h1 className=' text-[1.2rem] md:text-[1.8rem] font-semibold'>{ForHR.heading}</h1>
                        <p className='text-[0.8rem] md:text-[1.1rem]'>{ForHR.detail}</p>
                    </div>
                    <div
                        className='w-full px-4 py-4 rounded-xl border-[0.12rem] bg-black cursor-pointer md:py-6 lg:rounded-2xl'
                        onClick={(e) => ForCandidates?.redirect ? window.open(ForCandidates?.redirect) : Navigate(ForCandidates?.navigation)}
                    >
                        <h1 className=' text-[1.2rem] md:text-[1.8rem] font-semibold text-white'>{ForCandidates.heading}</h1>
                        <p className='text-[0.8rem] md:text-[1.1rem] text-white'>{ForCandidates.detail}</p>
                    </div>
                </div>

                <p className=' text-gray-400'>Already have an account ? <span className='text-black cursor-pointer' onClick={() => Navigate('/auth/login')}>Log in </span> </p>
                <p className='pt-1 text-gray-400 text-xs'>By continuing, you agree to Termns of Use and Privacy Policy  </p>
            </div>
        </div >
    )
}

export default AuthChild;